import React from "react";
import { Card, Col, Row, Spin, Statistic } from "antd";
import { fenToYuan } from "../../../utils/statistics/statisticsUtils";

export default function StatCardGrid({ items = [], loading = false, columns = 4 }) {
  const colSpan = Math.max(6, Math.floor(24 / columns));

  return (
    <Row gutter={[16, 16]}>
      {items.map((item) => (
        <Col key={item.key || item.title} xs={24} sm={12} md={colSpan}>
          <Card bordered={false} className="statistics-page__stat-card">
            <Spin spinning={loading}>
              {item.money ? (
                <Statistic title={item.title} prefix="¥" value={fenToYuan(item.value)} />
              ) : (
                <Statistic
                  title={item.title}
                  value={item.value ?? 0}
                  suffix={item.suffix}
                />
              )}
            </Spin>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export function buildMoneyCard(key, title, valueFen) {
  return {
    key,
    title,
    money: true,
    value: valueFen,
  };
}
